// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Copy as RawCopy } from "lucide-react";
export const Copy = /* @__PURE__ */ createIcon(RawCopy, "Copy", 2);
